import type { MediaDTO } from "@wedding/shared-types";
import { thumbnailUrl } from "../../api/media.js";

interface MediaCardProps {
  media: MediaDTO;
  onOpen: () => void;
  selectionMode?: boolean;
  selected?: boolean;
  onToggleSelect?: () => void;
}

export function MediaCard({
  media,
  onOpen,
  selectionMode = false,
  selected = false,
  onToggleSelect,
}: MediaCardProps) {
  const aspectRatio = media.width && media.height ? `${media.width} / ${media.height}` : "1 / 1";

  return (
    <button
      type="button"
      onClick={selectionMode ? onToggleSelect : onOpen}
      style={{
        position: "relative",
        border: selected ? "3px solid var(--color-primary)" : "none",
        padding: 0,
        cursor: "pointer",
        background: "var(--color-border)",
        borderRadius: "var(--radius-sm)",
        overflow: "hidden",
        aspectRatio,
        width: "100%",
      }}
      aria-label={
        selectionMode
          ? `${selected ? "Désélectionner" : "Sélectionner"} ${media.originalName}`
          : media.type === "video"
            ? `Lire la vidéo ${media.originalName}`
            : `Voir la photo ${media.originalName}`
      }
      aria-pressed={selectionMode ? selected : undefined}
    >
      {media.thumbnailStatus === "ready" ? (
        <img
          src={thumbnailUrl(media.id)}
          alt=""
          loading="lazy"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {media.thumbnailStatus === "failed" ? (
            <span style={{ fontSize: "0.75rem", color: "var(--color-text-muted)", padding: "0 8px", textAlign: "center" }}>
              Miniature indisponible
            </span>
          ) : (
            <span className="spinner" aria-hidden />
          )}
        </div>
      )}
      {media.type === "video" && !selectionMode && (
        <span
          aria-hidden
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "rgba(0,0,0,0.55)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="white">
              <path d="M4 2.5v11l10-5.5-10-5.5z" />
            </svg>
          </span>
        </span>
      )}
      {selectionMode && (
        <span
          aria-hidden
          style={{
            position: "absolute",
            top: 6,
            right: 6,
            width: 24,
            height: 24,
            borderRadius: "50%",
            background: selected ? "var(--color-primary)" : "rgba(255,255,255,0.85)",
            border: selected ? "none" : "2px solid rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {selected && (
            <svg width="14" height="14" viewBox="0 0 16 16" fill="white">
              <path d="M6.5 11.5 3 8l1.4-1.4L6.5 8.7l5.1-5.1L13 5z" />
            </svg>
          )}
        </span>
      )}
    </button>
  );
}
